import { useMemo } from "react";
import { useAppSelector } from "src/app/hooks";

type UserOfficePrivilege = {
  ID: number | null;
  OFF_ID: number | null;
  OFFICE_NAME: string | null;
};

export function useSelectedOffice() {
  const { user, selectedOfficeId } = useAppSelector((state) => state.auth);

  const selectedOffice = useMemo<UserOfficePrivilege | null>(() => {
    const offices = user?.UserAssPriviliges ?? [];
    return (
      offices.find((office) => Number(office.ID) === Number(selectedOfficeId)) ??
      offices[0] ??
      null
    );
  }, [selectedOfficeId, user]);

  const effectiveOffId = useMemo(
    () => Number(selectedOffice?.OFF_ID || user?.UserAssPriviliges?.[0]?.OFF_ID || 0),
    [selectedOffice, user]
  );

  return {
    selectedOfficeId: selectedOfficeId || 0,
    selectedOffice,
    effectiveOffId,
  };
}
